"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundWebcastComponent = function (_React$Component) {
  _inherits(FundWebcastComponent, _React$Component);

  function FundWebcastComponent(props) {
    _classCallCheck(this, FundWebcastComponent);

    return _possibleConstructorReturn(this, (FundWebcastComponent.__proto__ || Object.getPrototypeOf(FundWebcastComponent)).call(this, props));
  }

  _createClass(FundWebcastComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var script = document.createElement("script");
      script.src = "https://www.brighttalk.com/clients/js/player-embed/player-embed.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, {
    key: "render",
    value: function render() {

      if ((0, _ramda.isNil)(this.props.channelId)) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        { className: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12" },
        _react2.default.createElement(
          "div",
          { className: "jsBrightTALKEmbedWrapper" },
          _react2.default.createElement(
            "script",
            { className: "jsBrightTALKEmbedConfig", type: "application/json" },
            this.props.commId ? "{\"channelId\" :" + this.props.channelId + ", \"commId\" : " + this.props.commId + ",\"displayMode\" : \"standalone\",\"height\" : \"auto\"}" : "{\"channelId\" :" + this.props.channelId + ", \"displayMode\" : \"channelList\",\"height\" : \"auto\"}"
          )
        )
      );
    }
  }]);

  return FundWebcastComponent;
}(_react2.default.Component);

exports.default = FundWebcastComponent;